import instance from "@/services/axiosConfig";
import appInstance from "./applicationService/appinstance";

const ownerService = {
  getShipDetails: async () => appInstance.get(`/admin/getShipdetails`),
  getDepartmentshiplist: async (payload) =>
    appInstance.post(`/ownersettings/departshiplist`, payload),

  getOwnerHierarchy: async (owner_id) => {
    const response = await appInstance.get(
      `/ownersettings/getownergroupdetails/${owner_id}`
    );
    return response.data;
  },
  updateOwnerdetail: async (payload) =>
    appInstance.put(`/ownersettings/updateownerdata`, payload),

  createOwnerGroup: async (payload) =>
    appInstance.post(`/ownersettings/addownergroup`, payload),

  updateOwnerGroup: async (payload) =>
    appInstance.put(`/ownersettings/updateownerGroup`, payload),

  getShiplistbydepartment: async (payload) =>
    appInstance.post(`/ownersettings/departshiplist`, payload),

  deleteOwnerGroup: async (id) =>
    appInstance.delete(`/ownersettings/deleteownerGroup/${id}`),

  createFleet: async (payload) =>
    appInstance.post(`/ownersettings/addfleets`, payload),

  updateFleet: async (payload) =>
    appInstance.put(`/ownersettings/updatefleets`, payload),

  deleteFleet: async (id) =>
    appInstance.put(`/ownersettings/deletefleetgroup/${id}`),

  viewAllFleets: async (owner_id) => {
    if (owner_id)
      return appInstance.get(`/ownersettings/getownerfleets/${owner_id}`);
    else return appInstance.get(`/ownersettings/getownerfleets/`);
  },
  viewAllShips: async () => {
    return appInstance.get(`/ownersettings/getownerships`);
  },
  viewAllOwnerGroups: async (owner_id) => {
    if (owner_id)
      return appInstance.get(`/ownergroup/getownergroup/${owner_id}`);
    else return appInstance.get(`/ownergroup/getownergroup`);
  },

  viewOwnerUsergroups: async () =>
    appInstance.get(`/ownersettings/getAllusergroup`),

  deleteOwnerUsergroups: async (id) =>
    appInstance.put(`/ownersettings/deleteusergroups/${id}`),
  addownerUsergroup: async (payload) =>
    appInstance.post(`/ownersettings/addownerusers`, payload),
  updateownerUsergroup: async (payload) =>
    appInstance.put(`/ownersettings/updateownerusers`, payload),
  viewsingleusergroup: async (groupid) =>
    appInstance.get(`/ownersettings/getusergroupbyid/${groupid}`),

  getownermodule: async () => instance.get(`/owner/ownermodules`),
  getownerChart: async (payload) => instance.post(`/owner/dynamicchart`, payload),
  getchartmetadetails: async (topic, imo_number) => instance.get(`/owner/getchartmetadetails/${topic}/${imo_number}`),
  getpermissionAudit: async ({ page, limit }) => appInstance.get('/ownersettings/getpermissionaudit', {
    params: { page, limit }
  }), savepermissionAudit: async (payload) => appInstance.post(`/ownersettings/updateAudit`, payload),

  getVoyageGroups: async (imo) => instance.get(`/owner/voyage-groups?imo=${imo}`),

  getVoyageRows: (params) => instance.get(`/owner/voyage-rows`, { params })
};

export default ownerService;
